var config = {
	'ajax_url' : window.location.origin + '/wp/wp-admin/admin-ajax.php'
}

export default config;


// WEBPACK FOOTER //
// ./resources/assets/js/config.js